import { usePageTitle } from "@/hooks/usePageTitle";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import { formatApiError } from "@/lib/api";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

const LOGO = "https://customer-assets-jai6qajn.emergentagent.net/job_inbody-powered/artifacts/cgjm5igj_FB%20Cover%20logo.png";

export default function ResetPassword() {
  usePageTitle("Reset Password");
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setErr("Passwords do not match"); return; }
    setErr(""); setBusy(true);
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/reset-password`, { token, password });
      toast.success("Password updated! Please log in with your new password.");
      navigate("/login");
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail) || e.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-12 bg-[#F5F5F4]">
      <div className="w-full max-w-md bg-white rounded-2xl border border-[#E7E5E4] shadow-sm p-8">
        <Link to="/" className="flex justify-center mb-6"><img src={LOGO} alt="MBBC" className="h-14 w-14 object-contain" /></Link>
        <h2 className="font-heading text-2xl text-navy text-center">Choose a new password</h2>
        {!token ? (
          <p className="mt-4 text-center text-sm text-red-600" data-testid="reset-no-token">
            This reset link is invalid. <Link to="/forgot-password" className="text-teal font-medium">Request a new one</Link>
          </p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <input data-testid="reset-password" type="password" required minLength={6} placeholder="New password (min 6 chars)"
              value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-white border border-[#E7E5E4] rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-teal/20 focus:border-teal" />
            <input data-testid="reset-confirm" type="password" required minLength={6} placeholder="Confirm new password"
              value={confirm} onChange={(e) => setConfirm(e.target.value)}
              className="w-full bg-white border border-[#E7E5E4] rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-teal/20 focus:border-teal" />
            {err && <p data-testid="reset-error" className="text-sm text-red-600">{err}</p>}
            <button data-testid="reset-submit" disabled={busy} type="submit"
              className="w-full bg-navy text-white hover:bg-navy-dark transition-colors rounded-lg py-3 font-medium flex items-center justify-center gap-2 disabled:opacity-60">
              {busy && <Loader2 className="w-4 h-4 animate-spin" />} Update password
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
